import { PasskeyEnrollmentPrompt } from "gsintegrations";
import { useEffect, useState } from "react";
import { useAuth } from "../auth/useAuth";
import usePasskeyCredentialsQuery from "../hooks/usePasskeyCredentialsQuery";
import usePasskeyRegisterMutation from "../hooks/usePasskeyRegisterMutation";
import { usePasskeySupport } from "../hooks/usePasskeySupport";
import {
  dismissPasskeyEnrollmentPrompt,
  isPasskeyEnrollmentDismissed,
} from "../utils/passkeyEnrollmentStorage";
import { toast } from "../utils/toast";

const PasskeyEnrollmentGate = () => {
  const { isAuthenticated } = useAuth();
  const { supported, checked } = usePasskeySupport();
  const { data: credentials = [], isSuccess } = usePasskeyCredentialsQuery();
  const registerMutation = usePasskeyRegisterMutation();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (
      !isAuthenticated ||
      !checked ||
      !supported ||
      !isSuccess ||
      credentials.length > 0 ||
      isPasskeyEnrollmentDismissed()
    ) {
      setOpen(false);
      return;
    }

    setOpen(true);
  }, [checked, credentials.length, isAuthenticated, isSuccess, supported]);

  const handleDismiss = () => {
    dismissPasskeyEnrollmentPrompt();
    setOpen(false);
  };

  const handleActivate = async () => {
    try {
      await registerMutation.mutateAsync();
      toast.success("Biometria ativada com sucesso.");
      setOpen(false);
    } catch (error) {
      toast.error(
        error instanceof Error
          ? error.message
          : "Não foi possível ativar a biometria.",
      );
    }
  };

  return (
    <PasskeyEnrollmentPrompt
      open={open}
      loading={registerMutation.isPending}
      onActivate={() => {
        void handleActivate();
      }}
      onDismiss={handleDismiss}
    />
  );
};

export default PasskeyEnrollmentGate;
